import type { Node, PathRef } from 'slate';
import type { ReactEditor } from 'slate-react';

import type { MenuItemProps } from '@lumapps/lumx-menu/components/Menu/MenuItem';

/**
 * Same as NodeEntry but using PathRef instead of Path.
 */
export type NodeEntryRef<T extends Node> = [T, PathRef];

/**
 * Custom editor type extending ReactEditor
 */
export type WrexEditor<P = Record<string, never>> = ReactEditor & P;

/**
 * All available types in ToolbarItem
 */
export enum TOOLBAR_ITEM_TYPE {
    OPTION = 'option',
    TOGGLE_OPTION = 'toggle-option',
    DIVIDER = 'divider',
    SUBMENU = 'submenu',
    SECTION = 'section',
}

export interface OptionToolbarItem {
    type: 'option';
    onClick: (event?: any) => void;
}

export interface ToggleOptionToolbarItem {
    type: 'toggle-option';
    isChecked: boolean;
    onClick: (event?: any) => void;
}

export interface DividerToolbarItem {
    type: 'divider';
}

export interface SubmenuToolbarItem<T = any> {
    type: 'submenu';
    childrenOptions: T[];
}

export interface SectionToolbarItem<T = any> {
    type: 'section';
    childrenOptions: T[];
}

export type ToolbarItem = {
    itemKey: string;
    label?: string | React.ReactElement;
    tooltipLabel?: string;
    icon?: string;
    isDisabled?: boolean;
    'aria-disabled'?: boolean;
    otherProps?: any;
    verticalModeProps?: Omit<ToolbarItem, 'itemKey' | 'type' | 'verticalModeProps'>;
    inVerticalMode?: boolean;
    rowIndex?: number;
    helper?: string;
    isReadOnly?: boolean;
    variant?: MenuItemProps['variant'];
} & (
    | OptionToolbarItem
    | DividerToolbarItem
    | SectionToolbarItem<ToolbarItem>
    | ToggleOptionToolbarItem
    | SubmenuToolbarItem<ToolbarItem>
);
